import React from 'react';
import { SolutionsIntro } from '../components/solutions/SolutionsIntro';
import { EmbeddedSolution } from '../components/solutions/EmbeddedSolution';
import { SolutionsCycle } from '../components/solutions/SolutionsCycle';
export function SolutionsPage() {
  return <>
      <SolutionsIntro data-id="element-3532" data-mp="12jvcyv5wujdy" />
      <EmbeddedSolution id="research" anchor="scientific-research" data-id="element-3533" data-mp="12k56gsq5z8oe" />
      <EmbeddedSolution id="clinical" anchor="clinical" data-id="element-3534" data-mp="4w4u207igq2g" />
      <SolutionsCycle data-id="element-3535" data-mp="4xg066ofi9wq" />
    </>;
}